import React, { useContext } from 'react'
import { ButtonSecondary } from '@creditas-ui/react'
import { object, string } from 'prop-types'
import { PRODUCT_TYPE_DESCRIPTION, PROPOSAL_STEP } from 'domain/enums'
import { formatDate, formatMoney, formatCpf } from 'shared/helpers'
import { DrawerContext, DRAWER_TYPES } from 'shared/ui'
import { Title, ProposalWrapper, Item, Label, Value } from './Lead.styles'

const Proposal = ({ proposal, product }) => {
  const { openDrawer } = useContext(DrawerContext)

  const showCreditAnalysis = () => {
    if (proposal.creditAnalysis) {
      return (
        <ButtonSecondary
          onClick={() => openDrawer(DRAWER_TYPES.CREDIT_ANALYSIS)}
        >
          Detalhes das condições do crédito aprovado
        </ButtonSecondary>
      )
    }

    return null
  }

  const showCreditPayment = () => {
    if (proposal.creditPayment) {
      return (
        <ButtonSecondary
          onClick={() => openDrawer(DRAWER_TYPES.CREDIT_PAYMENT)}
        >
          Detalhes das condições do empréstimo pago
        </ButtonSecondary>
      )
    }

    return null
  }

  return proposal ? (
    <ProposalWrapper>
      <Title variant="h4">Resumo da proposta</Title>
      <Item data-testid="proposal-product">
        <Label>Produto</Label>
        <Value>{PRODUCT_TYPE_DESCRIPTION[product]}</Value>
      </Item>
      {proposal.conditions?.approvedCredit?.amount && (
        <Item data-testid="proposal-approved-credit">
          <Label>Valor Aprovado</Label>
          <Value>
            {formatMoney(proposal.conditions?.approvedCredit?.amount)}
          </Value>
        </Item>
      )}
      <Item data-testid="proposal-intended-credit">
        <Label>Valor Solicitado</Label>
        <Value>{formatMoney(proposal.intendedCredit?.amount)}</Value>
      </Item>
      <Item data-testid="proposal-creation-date">
        <Label>Data de criação</Label>
        <Value>{formatDate(proposal.conditions?.createdAt)}</Value>
      </Item>
      <Item data-testid="proposal-cpf">
        <Label>CPF</Label>
        <Value>{formatCpf(proposal.borrower?.cpf)}</Value>
      </Item>
      {showCreditAnalysis()}
      {showCreditPayment()}
    </ProposalWrapper>
  ) : null
}

Proposal.propTypes = {
  proposal: object,
  product: string,
}

export { Proposal }
